#import "../../../../core/schema/fragments/WeddingFormFull.graphql"

query (
  $id: ID!
) {
  getWeddingForm(
    id: $id
  ) {
    ...WeddingFormFull
  }
}
